import { render, staticRenderFns } from "./repairedExamine.vue?vue&type=template&id=bc45d93c&scoped=true&"
import script from "./repairedExamine.vue?vue&type=script&lang=js&"
export * from "./repairedExamine.vue?vue&type=script&lang=js&"
import style0 from "./repairedExamine.vue?vue&type=style&index=0&id=bc45d93c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc45d93c",
  null
  
)

export default component.exports